import { ReactNode } from 'react';
import { CookieConsentContext, useCookieConsent } from '@/hooks/use-cookie-consent';

// Feature flag: Set to false to disable cookie consent banner (not required outside EU)
const COOKIE_CONSENT_ENABLED = false;

interface CookieConsentProviderProps {
  children: ReactNode;
}

export function CookieConsentProvider({ children }: CookieConsentProviderProps) {
  const cookieConsent = useCookieConsent();

  return (
    <CookieConsentContext.Provider value={cookieConsent}>
      {children}
      {COOKIE_CONSENT_ENABLED && (
        <LazyBanner />
      )}
    </CookieConsentContext.Provider>
  );
}

// Lazy load banner only when enabled to avoid importing unused code
function LazyBanner() {
  const { CookieConsentBanner } = require('@/components/CookieConsentBanner');
  return <CookieConsentBanner />;
}
